/**
 * 枚举类型名大驼峰
 * 枚举key值大写蛇形命名
 * 取key值对应value属性
 * @param {Object} definition 枚举
 * @returns  {Object} {kay:value} 如{TRADEMARK_REG:0, TRADEMARK_OATH:1}
 **/
// 获取调用方法的行号
function warning(msg) {
  const error = new Error(msg)
  console.warn(error)
  // const stackFrames = error.stack.split("\n").slice(2);
  // const index = stackFrames.findIndex(v=>v.indexOf('GenerateEnum')>=0)+1
  // const callerFrame = stackFrames[index]?.split(":") || [];
  // const stackString = String(error.stack);
  // const stackArray = stackString.split(/\r?\n/);
  // console.log(stackArray);
  //
  // return callerFrame[callerFrame.length - 2] || "Unknown";
}

function deepClone(source, hash = new WeakMap()) {
  const type = judgeType(source)
  let target
  if (type === 'array') {
    target = []
  } else if (type === 'object') {
    target = {}
  } else {
    // 基础类型直接返回，不再具有下一层次
    return source
  }
  if (hash.has(source)) return hash.get(source) // 新增代码，查哈希表
  hash.set(source, target) // 新增代码，哈希表设值
  if (type === 'array') {
    // eslint-disable-next-line
        for (let i = 0, len = source.length; i < len; i++) {
      target.push(deepClone(source[i], hash))
    }
  } else if (type === 'object') {
    // 对原型上的方法也拷贝了....
    // eslint-disable-next-line
        for (const key in source) {
      target[key] = deepClone(source[key], hash)
    }
  }
  return target
}
function judgeType(target) {
  if (typeof Element !== 'undefined' && target instanceof Element) {
    return 'element'
  }
  // toString会返回对应不同的标签的构造函数
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
    '[object Array]': 'array',
    '[object Function]': 'function',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp'
  }
  return map[toString.call(target)]
}

function firstLetterToLowerCase(str = '') {
  return str.charAt(0).toLowerCase() + str.slice(1)
}

// 判断一个值是否为 null 或 undefined 或无穷大
function isNull(value) {
  return [null, undefined, ''].includes(value) && !Number.isFinite(value)
}

function allowEmptyValue(data) {
  return data?.allowEmptyValue === true
}

// 递归合并对象的辅助函数
function mergeObjects(target, ...sources) {
  sources.forEach((source) => {
    for (const key in source) {
      if (typeof source[key] === 'object' && source[key] !== null) {
        target[key] = mergeObjects(target[key] || {}, source[key])
      } else {
        target[key] = source[key]
      }
    }
  })
  return target
}
// 深冻结函数.
function deepFreeze(obj) {
  // 取回定义在obj上的属性名
  const propNames = Object.getOwnPropertyNames(obj)
  // 在冻结自身之前冻结属性
  propNames.forEach(function(name) {
    const prop = obj[name]
    // 如果prop是个对象，冻结它
    if (typeof prop == 'object' && prop !== null) {
      deepFreeze(prop)
    }
  })
  // 冻结自身(no-op if already frozen)
  return Object.freeze(obj)
}
// 生成枚举对象的主函数
export default function GenerateEnum(enumParams, defaultKey = 'value') {
  const dictionaries = deepClone(enumParams)
  // 根据每个枚举值的 key，将其值存入 enumValue，并检查是否为空
  const enumValue = Object.keys(dictionaries).reduce((data, key) => {
    const value = dictionaries[key]?.[defaultKey]
    if (isNull(value)) {
      if (!allowEmptyValue(dictionaries[key])) {
        warning(`枚举key值${key}的${defaultKey}内容为空，请检查以免出现bug`)
      }
    } else {
      data[key] = value
    }
    return data
  }, {})
  // 枚举对象的原型，包含各种方法和属性
  const proto = {
    // 获取枚举数据的只读副本
    get enumData() {
      return deepFreeze(dictionaries)
    },
    // 获取枚举数据的只读数组
    get enumArray() {
      return Object.values(this.enumData)
    },
    // 模糊匹配，根据值获取对应的枚举数据
    fuzzyMatch(value, key) {
      return deepFreeze(Object.values(dictionaries).find((info = {}) => (key ? value === dictionaries[key] : Object.keys(info).some((k) => info[k] === value))))
    },
    // 根据指定的键过滤掉多个对应的数据，生成新的枚举对象
    getEnumFilter(...args) {
      const params = args?.flat()
      return new GenerateEnum(Object.fromEntries(Object.entries(dictionaries).filter(([value]) => !params.includes(value))), defaultKey)
    },
    // 根据指定的键对应的数据生成新的枚举对象
    generateEnumValue(...args) {
      const params = args?.flat()
      return new GenerateEnum(Object.fromEntries(Object.entries(dictionaries).filter(([value]) => params.includes(value))), defaultKey)
    },
    //合并枚举,对象新增与替换
    reviseEnum(...args) {
      const enums = { ...dictionaries }
      const isMarge = args[args.length - 1]
      const list = args.map((v) => v?.enumData || v)
      const data = typeof isMarge === 'boolean' && isMarge ? Object.fromEntries(Object.entries(mergeObjects(enums, ...list)).filter(([, v]) => v)) : Object.assign(enums, ...list)
      return new GenerateEnum(data, defaultKey)
    }
  }
  // 对所有枚举值进行合并处理
  const proxy = new Proxy(proto, {
    get(target, prop) {
      if (typeof prop === 'string') {
        //以enumTo开头转发
        const enumTo = 'enumTo'
        const regexEnumTo = /enum(.+)To(.+)/
        const regexGetActive = /get(.+)To(.+)/
        if (prop.startsWith(enumTo)) {
          const key = firstLetterToLowerCase(prop.slice(enumTo.length))
          if (key) {
            return Object.fromEntries(
              Object.entries(dictionaries).map(([k, v]) => {
                const value = v[key]
                isNull(value) && !allowEmptyValue(v) && warning(`枚举${prop}取值${key}内容为空，请检查以免出现bug`)
                return [k, value]
              })
            )
          }
        } else if (regexEnumTo.test(prop)) {
          const [, value, label] = regexEnumTo.exec(prop) || []
          const valCase = firstLetterToLowerCase(value)
          const labelCase = firstLetterToLowerCase(label)
          const map = new Map(
            Object.entries(dictionaries).map(([label, v]) => {
              const data = v[labelCase]
              isNull(data) && !allowEmptyValue(v) && warning(`枚举${label}值${labelCase}内容为空，请检查以免出现bug`)
              return [v[valCase], data]
            })
          )
          return Object.fromEntries(map)
        } else if (regexGetActive.test(prop)) {
          const [, value, label] = regexGetActive.exec(prop) || []
          const valCase = firstLetterToLowerCase(value)
          const labelCase = firstLetterToLowerCase(label)
          return (value) => Object.values(proxy.enumData).find((v) => v[valCase] === value)?.[labelCase]
        }
      }
      return target[prop]
    }
  })
  // 将枚举对象的原型设置为 proto，并返回一个不可修改的枚举对象
  return deepFreeze(Object.setPrototypeOf(enumValue, proxy))
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/generateEnum.js